import { render, staticRenderFns } from "./TlmCheckoutMenuPanel.vue?vue&type=template&id=5a8e0a4c"
import script from "./TlmCheckoutMenuPanel.vue?vue&type=script&lang=js"
export * from "./TlmCheckoutMenuPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmCheckoutMenus: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/TlmCheckoutMenus.vue').default})
